import {
	SET_REVIEWS_INFO,
	SET_CURR_AVG_AND_TOTAL_RATING
} from '../actions/types';

export default function reviewsInfo(state = {}, action) {
	if (!action.error && action.payload !== undefined) {
		switch (action.type) {
			case SET_REVIEWS_INFO:
				// eslint-disable-next-line no-case-declarations
				const {
					avgRating,
					totalRatings,
					currentAvgRating,
					currentTotalRatings
				} = action.payload;
				return {
					...state,
					avgRating,
					totalRatings,
					currentAvgRating,
					currentTotalRatings
				};
			case SET_CURR_AVG_AND_TOTAL_RATING:
				return {
					...state,
					currentAvgRating: action.payload.avgRating,
					currentTotalRatings: action.payload.totalRating
				};
			// no default
		}
	}

	return state;
}
